import React from 'react'
import PropTypes from 'prop-types'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import Card from 'components/Card/Card.jsx'
import CardBody from 'components/Card/CardBody.jsx'
import ProfileForm from 'views/Forms/ProfileForm'
import ChangePwdForm from 'views/Forms/ChangePwdForm'
import IbanBicForm from 'views/Forms/IbanBicForm'
import api from 'api'
import style from "assets/css/style.jsx"
import pricingPageStyle from 'assets/jss/material-dashboard-pro-react/views/pricingPageStyle.jsx'

const styles = require(`../../assets/css/style.jsx`).default;

class ProfilePage extends React.Component {
  state = {
    user: null
  }

  componentWillMount() {
    api.user.get_curr()
      .then(resp => {
        this.setState({ user: resp.data })
      })
  }

  render() {
    const { classes } = this.props
    const { user } = this.state

    return (
      <div className={classes.content}>
        <div className={classes.container}>
          <GridContainer justify='center'>
            <GridContainer justify='center'>
              <GridItem xs={12} sm={12} md={6}>
                <h1 style={styles.titleWhite}>Mon profil</h1>
              </GridItem>
            </GridContainer>
            <GridItem xs={12} sm={12} md={10}>
              <Card className={classes.cardSignup}>
                <CardBody>
                  <GridContainer justify='center'>
                    <GridItem sm={12} md={7}>
                      <h4 className={classes.cardTitle + ' ' + classes.titleProfil }>Modifier mon profil</h4>
                      <ProfileForm classes={classes} />
                    </GridItem>
                    <GridItem sm={12} md={5}>
                      <h4 className={classes.cardTitle  + ' ' + classes.titleProfil}>Modifier mes coordonnées bancaires</h4>
                      <IbanBicForm classes={classes} user={user}/>
                      <h4 className={classes.cardTitle  + ' ' + classes.titleProfil}>Modifier mon mot de passe</h4>
                      <ChangePwdForm classes={classes} />
                    </GridItem>
                  </GridContainer>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

ProfilePage.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(style,   ...pricingPageStyle
)(ProfilePage)



// WEBPACK FOOTER //
// ./src/views/Pages/ProfilePage.jsx